export { default } from './InformativeBox';
